function setLocale (locale: string) {
  document.cookie = `NEXT_LOCALE=${locale}; path=/`
}

export default setLocale
